import { render, staticRenderFns } from "./Legitimate.vue?vue&type=template&id=165a8b2a&scoped=true&"
import script from "./Legitimate.vue?vue&type=script&lang=js&"
export * from "./Legitimate.vue?vue&type=script&lang=js&"
import style0 from "./Legitimate.vue?vue&type=style&index=0&id=165a8b2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a8b2a",
  null
  
)

export default component.exports